import { render, staticRenderFns } from "./MarketingPrograms.vue?vue&type=template&id=7ffd6ce8&"
import script from "./MarketingPrograms.vue?vue&type=script&lang=js&"
export * from "./MarketingPrograms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports